<template>
  <v-row dense>
    <v-col>
      <v-row dense>
        <v-col>
          <v-combobox
            label="Fabricante"
            v-model="manufacturer"
            hide-details
            outlined
            dense
            background-color="white"
            :items="manufacturers"
            item-text="name"
            @change="changeManufacturer"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-combobox
            label="Tipo"
            v-model="prosthesisType"
            hide-details
            outlined
            dense
            background-color="white"
            :items="prosthesisTypes"
            item-text="name"
            @change="changeProsthesisType"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-combobox
            label="Modelo"
            v-model="model"
            outlined
            dense
            background-color="white"
            :items="models"
            item-text="name"
            :hide-details="errors.model === undefined"
            :error-messages="errors.model"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-combobox
            label="Dioptria"
            v-model="diopter"
            hide-details
            outlined
            dense
            :menu-props="{ auto: true, maxHeight: 304 }"
            background-color="white"
            :items="diopters"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-text-field
            label="Lote"
            v-model="batch"
            hide-details
            outlined
            dense
            background-color="white"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-textarea
            label="Observações"
            v-model="observation"
            hide-details
            outlined
            dense
            background-color="white"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-btn
            color="primary"
            block
            small
            @click="saveProsthesis"
            :disabled="disabled"
          >
            Salvar prótese
          </v-btn>
        </v-col>

        <v-col cols="4">
          <v-btn color="secondary" block small @click="cancelProsthesis"
            >Cancelar</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ProsthesisForm",
  props: {
    surgery: Object,
    prosthesis: Object,
    refreshProstheses: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: {},
      manufacturer: null,
      prosthesisType: null,
      model: null,
      diopter: "Em branco",
      observation: "",
      batch: "",
    };
  },
  watch: {
    prosthesis() {
      this.loadSurgeryProsthesis();
    },
  },
  apollo: {
    prostheses: {
      query: require("@/graphql/prosthesis/prostheses.gql"),
    },
  },
  computed: {
    diopters() {
      let diopters = [];

      for (let index = -10; index <= 34; index += 0.5) {
        let dipoter = `${index.toFixed(2)}`;

        if (index >= 0) {
          dipoter = `+${index.toFixed(2)}`;
        }

        diopters.push(dipoter.replace(".", ","));
      }

      diopters.splice(diopters.length / 2, 0, "Em branco");

      return diopters;
    },
    manufacturers() {
      if (this.prostheses) {
        return this.lodash.orderBy(
          this.lodash.filter(
            this.lodash.uniqBy(
              this.prostheses.map((e) => e.manufacturer),
              "id"
            ),
            ["deletedAt", null]
          ),
          [
            (e) =>
              e.name
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""),
          ],
          ["asc"]
        );
      }

      return [];
    },
    prosthesisTypes() {
      if (this.prostheses && this.manufacturer?.id) {
        let prostheses = this.lodash.filter(
          this.prostheses,
          function (e) {
            return e.manufacturer.id === this.manufacturer.id;
          }.bind(this)
        );

        return this.lodash.uniqBy(
          prostheses.map((e) => e.prosthesisType),
          "id"
        );
      }

      return [];
    },
    models() {
      let prostheses = this.prostheses;

      if (this.manufacturer?.id) {
        prostheses = this.lodash.filter(
          prostheses,
          function (e) {
            return e.manufacturer.id === this.manufacturer.id;
          }.bind(this)
        );
      }

      if (this.prosthesisType?.id) {
        prostheses = this.lodash.filter(
          prostheses,
          function (e) {
            return e.prosthesisType.id === this.prosthesisType.id;
          }.bind(this)
        );
      }

      return prostheses;
    },
  },
  methods: {
    changeManufacturer() {
      this.prosthesisType = null;
      this.changeProsthesisType();
    },
    changeProsthesisType() {
      this.model = null;
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (this.model === "") {
        this.errors.model = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    saveProsthesis() {
      if (this.disabled) return;

      return this.apolloMutate({
        mutation: require("@/graphql/surgery/save_prosthesis_surgery_intraoperative.gql"),
        variables: {
          surgeryId: this.surgery.id,
          prosthesisId: this.lodash.get(this.model, "id", ""),
          surgeryIntraoperativeProsthesisId: this.lodash.get(
            this.prosthesis,
            "id",
            ""
          ),
          diopter: this.diopter,
          observation: this.observation,
          batch: this.batch,
        },
      }).then(() => {
        this.cancelProsthesis();
      });
    },
    loadSurgeryProsthesis() {
      if (this.prosthesis) {
        this.diopter = this.prosthesis.diopter;
        this.observation = this.prosthesis.observation;
        this.batch = this.prosthesis.batch;

        this.model = this.lodash.find(this.models, {
          id: this.prosthesis.prosthesis.id,
        });

        this.manufacturer = this.model.manufacturer;
        this.prosthesisType = this.model.prosthesisType;
      } else {
        this.cancelProsthesis();
      }
    },
    cancelProsthesis() {
      this.diopter = "Em branco";
      this.observation = "";
      this.model = "";
      this.manufacturer = "";
      this.prosthesisType = "";
      this.batch = "";

      this.refreshProstheses();
    },
  },
};
</script>

<style lang="scss" scoped></style>
